import type { MinutesJobStatus } from '@ai-meeting/shared'
import { apiClient, toApiError } from './api'
import { getServiceStrings } from './i18n'

/**
 * Fetch one poll of an internal meeting's minutes job.
 *
 * The job id is the only thing guarding these minutes upstream, so it travels
 * in the path of our own authenticated proxy and is never put anywhere it would
 * be recorded — no query string, no analytics, no log line.
 *
 * @param jobId Opaque id from `meeting-minutes.queued`.
 * @throws ApiError with status 404 once the job has expired or never existed.
 *   That is terminal: upstream keeps jobs in process memory, so there is nothing
 *   left to retry against.
 */
export async function fetchMinutesJob(jobId: string): Promise<MinutesJobStatus> {
  try {
    const { data } = await apiClient.get<MinutesJobStatus>(
      `/api/ai/meeting/minutes-jobs/${encodeURIComponent(jobId)}`
    )
    return data
  } catch (error) {
    throw toApiError(error, getServiceStrings().minutesJobPollFailed)
  }
}
